import BigNumber from "bignumber.js";

/**
 * 桁数で切り捨てされた値を取得
 *
 * @param targetValue
 * @param digit
 * @param method
 * @returns {number|*}
 */
window.getFloorValueForDigit = function (targetValue, digit, method = 3) {

    /** validation */
    if (typeof digit === 'undefined') {
        return targetValue;
    }
    if (typeof digit === 'string') {
        digit = parseInt(digit);
    }

    /** 端数処理 */
    // 切り捨て
    if (method === 1) {
        return BigNumber(targetValue).dp(digit, BigNumber.ROUND_DOWN).toNumber();
    }
    // 切り上げ
    if (method === 2) {
        return BigNumber(targetValue).dp(digit, BigNumber.ROUND_UP).toNumber();
    }
    //　四捨五入
    if (method === 3) {
        return BigNumber(targetValue).dp(digit, BigNumber.ROUND_HALF_UP).toNumber();
    }

    // 上記以外はないのでそのまま返しておく
    return targetValue;
}
